import {
  Bot, Brain, Calendar, ChartBar, ChartLine, ChartPie, DollarSign, FileText, FlaskConical, Gauge,
  Lightbulb, Map, Megaphone, Rocket, Search, Sparkles, Target, TrendingUp, Users, Zap,
  type LucideIcon,
} from "lucide-react";

// Keys match ALLOWED_ICONS in adrsta-models app/core/studio/templates.py.
export const AGENT_ICONS: Record<string, LucideIcon> = {
  bot: Bot,
  brain: Brain,
  sparkles: Sparkles,
  "chart-line": ChartLine,
  "chart-bar": ChartBar,
  "chart-pie": ChartPie,
  "trending-up": TrendingUp,
  target: Target,
  gauge: Gauge,
  megaphone: Megaphone,
  users: Users,
  "dollar-sign": DollarSign,
  "flask-conical": FlaskConical,
  map: Map,
  lightbulb: Lightbulb,
  search: Search,
  "file-text": FileText,
  calendar: Calendar,
  zap: Zap,
  rocket: Rocket,
};

export default function AgentIcon({ icon, className }: { icon: string; className?: string }) {
  const Icon = AGENT_ICONS[icon] ?? Bot;
  return <Icon className={className} />;
}
